import React, { forwardRef, useState } from 'react';

const inputStyle = {
    display: 'flex',
    height: '2.5rem',
    width: '100%',
    borderRadius: 'var(--radius-md)',
    border: '1px solid var(--border-strong)',
    backgroundColor: 'var(--surface-raised)',
    padding: '0.5rem 0.75rem',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    color: 'var(--text)',
    fontFamily: 'var(--font-ui)',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease'
};

const Input = forwardRef(({ className = '', type = 'text', error, disabled, style, onFocus, onBlur, ...props }, ref) => {
    const [focused, setFocused] = useState(false);

    const handleFocus = (e) => {
        setFocused(true);
        onFocus?.(e);
    };

    const handleBlur = (e) => {
        setFocused(false);
        onBlur?.(e);
    };

    const dynamicStyle = {
        ...inputStyle,
        ...(error ? { borderColor: 'var(--danger)' } : {}),
        ...(focused && !error ? {
            borderColor: 'var(--focus-ring)',
            boxShadow: '0 0 0 2px var(--accent-soft)'
        } : {}),
        ...(disabled ? {
            backgroundColor: 'var(--surface-sunken)',
            opacity: 0.6,
            cursor: 'not-allowed'
        } : {}),
        ...style
    };

    return (
        <input
            type={type}
            disabled={disabled}
            className={className}
            style={dynamicStyle}
            onFocus={handleFocus}
            onBlur={handleBlur}
            ref={ref}
            {...props}
        />
    );
});

Input.displayName = 'Input';

export { Input, inputStyle };
export default Input;
